import React, { useEffect } from 'react';
import Chart from 'chart.js-v3/auto';

const LineChart = ( { ctx, datasets, backgroundColor, numberWithCommas} ) => {

  useEffect(() => {
    $(`#${ctx}`).remove();
    $(`#${ctx}-container`).append(`<canvas id='${ctx}'></canvas>`);
    const options = { 
      scales: {
        y: {
          beginAtZero: true
          }
        },
      plugins: {
        legend: {
          display: true,
          position: 'bottom',
          align: 'start'
        },
        messages: {empty: "No data for this period"},
        elements: { 
          line: { tension: 0 }
        },
        title: {
          display: true,
          text: 'Cureus Article Reads',
          align: 'start',
          color: 'black',
          font: {
            size: 22,
            weight: 'bold',
          },
          padding: {
            top: 20,
            bottom: 20
          }
        },
        tooltip: {
          backgroundColor: 'white',
          mode: 'index',
          xPadding: 12,
          yPadding: 12,
          intersect: false,
          borderColor: "#9B9B9B", 
          borderWidth: 1, 
          titleAlign: "center", 
          titleMarginBottom: 10, 
          caretSize: 0,
          caretPadding: 10,
          titleColor: 'black',
          callbacks: {
            afterBody: function(tooltipItem, data) {
              var sum = 0;
              tooltipItem.forEach(function(item) {
                  sum += item.dataset.data[item.label]
              })
              return "Total: " + numberWithCommas(sum)
            },
            labelTextColor: function() {
              return 'black'
            }
          }
        }
      }
    }
    new Chart(ctx, {
      type: 'line',
      data: {
        datasets: datasets
      },
      options: options
    })
    if(backgroundColor) {
      $(`#${ctx}`).css('background-color', backgroundColor)
    }
  })

  return (
    <div className="metrics-charts" id={`${ctx}-container`}><canvas id={ctx}></canvas></div>
  )
}

export default LineChart;